/* eslint-disable @typescript-eslint/no-unused-vars */

const getInterfaceSign = (obj) => Object.getOwnPropertyNames(obj);

const services: { instance: any; sign: string[]; name: string }[] = [];

const ServiceContext = {
  services,
  register(service: any, name: string) {
    this.services.push({
      instance: service,
      sign: getInterfaceSign(service),
      name
    });
  },
  resolve<T>(name: string): T {
    const service = this.services.find((serv) => serv.name === name);

    if (service) return service.instance as T;
    throw new Error(`No instance`);
  }
};

export default ServiceContext;
